export default {
  methods: {
    hasState(prop) {
      return (
        typeof this[prop] !== 'undefined' &&
        this[prop] !== false &&
        this[prop] !== 'false'
      );
    },
    sendUserToUpgradePage() {
        window.open('https://tracking.groovesell.com/t/727e1806d803d6204296d7299c8ebbcf', '_blank');
    },
  }
};
